import * as THREE from "three";
import { Raycaster } from "three";

export const filterTargetsForRaycaster = (raycaster: Raycaster, targets: THREE.Object3D[]) => {
    const canRaycastSprites = Boolean((raycaster as any).camera);
    return canRaycastSprites
        ? targets
        : targets.filter((target) => target.type !== "Sprite");
};
